import React from 'react';
import { Field, Form } from 'react-final-form';
import Input from '@teetsh/app/src/components/Form/InputGroup/formWrapper';
import Dialog from '@teetsh/app/src/components/Dialog';
import Button from '@teetsh/app/src/components/Buttons/Button';
import useUpdateElevesView from '@teetsh/app/src/queries/eleves/views/useUpdateElevesView';
import { useRenameViewModal } from '@teetsh/app/src/containers/Eleves/List/Table/Views/RenameView/useRenameViewModal';
import { useTranslation } from 'react-i18next';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';

export function RenameViewModal() {
  const { payload, isOpen, closeModal } = useRenameViewModal();
  const update = useUpdateElevesView();
  const { t } = useTranslation(['common', 'eleve']);
  const { required } = useTranslatedValidation();
  const onSubmit = async ({ name }) => {
    if (payload?.view) {
      await update({
        ...payload.view,
        id: payload?.view?.id,
        name,
      }).then(() => closeModal());
    }
  };
  return (
    <Dialog
      onClose={closeModal}
      isOpen={isOpen}
      title={t('eleve:actions.renameList')}
    >
      <Form
        onSubmit={onSubmit}
        // C'est pour éviter que lorsque close la modal initialValue passe à empty et trigger un validation fucked
        initialValuesEqual={() => true}
        initialValues={{
          name: payload?.view?.name,
        }}
      >
        {({ handleSubmit, invalid, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Dialog.Body>
              <Field
                validate={required}
                name="name"
                id="rename-folder"
                large
                label={t('eleve:actions.newListName')}
                component={Input}
              />
            </Dialog.Body>
            <Dialog.Footer>
              <Button minimal onClick={closeModal}>
                {t('common:buttons.cancel')}
              </Button>
              <Button
                type="submit"
                loading={submitting}
                intent="primary"
                large
                disabled={invalid}
              >
                {t('common:buttons.rename')}
              </Button>
            </Dialog.Footer>
          </form>
        )}
      </Form>
    </Dialog>
  );
}
